const initialState = {
    nationalCode: '',
    insuranceId: null,
    insuranceTitle: '',
    hasSpecialDisease: null,
    diseaseName: null,
    hasSpecialMedication: null,
    medicationName: null,
    hasDrugAllergy: null,
    allergyDrugName: null,
};
const medicalRecords = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGES_MEDICAL_RECORDS':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default medicalRecords;
